<div style="font-size: 12px;">
    Your password must have at least:
    <ul class="abc">
      <li>8 characters long</li>
      <li>1 uppercase & 1 lowercase character</li>
      <li>1 number & 1 special character</li>
    </ul>
    </div> 
